<template>
  <b-card
    no-body
    class="card-statistics border border-secondary  "
  >
    <b-card-header>
      <b-card-title class="text-center alert">
        Sektörel Bazda  Kayıtlı Aboneler
      </b-card-title>
      <b-button variant="flat-info">
        <feather-icon icon="RefreshCwIcon" />

      </b-button>

    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in statisticsItems"
          :key="item.icon"
          md="3"
          sm="6"
          class="mb-2 mb-md-0"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
    <b-card-footer class="text-right alert alert-danger mr-2">
      Toplam Kayıtlı Abone Sayısı: 0
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardFooter, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody, BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BCardFooter,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BButton,
  },
  data() {
    return {
      statisticsItems: [
        {
          icon: 'CodepenIcon',
          color: 'light-primary',
          title: '0',
          subtitle: 'Demir-Çelik Sektörü',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'InboxIcon',
          color: 'light-info',
          title: '0',
          subtitle: 'Tekstil Sektörü',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'BoxIcon',
          color: 'light-danger',
          title: '0',
          subtitle: 'Kereste İmalatı Sektörü',
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'DollarSignIcon',
          color: 'light-success',
          title: '0',
          subtitle: 'Gıda Sektörü',
          customClass: 'mb-2 mb-sm-0',
        },
      ],

    }
  },
}
</script>
